import { CSSProperties } from 'react';
import colors from '../utils/colors';

export const MOBILE_TOP_BANNER_HEIGHT = 64;
export const MAP_HEIGHT = 500;

export default {
    container: {
        flex: 1,
        width: '100%',
        overflowX: 'hidden',
        position: 'relative'
    },
    topBanner: {
        zIndex: 100,
        position: 'absolute',
        top: 0,
        width: '100%',
        height: MOBILE_TOP_BANNER_HEIGHT,
        backgroundColor: colors.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `0 8px 12px ${colors.shadow}`
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        paddingBottom: 12
    },
    statusDescription: {
        marginTop: 12,
        marginBottom: 20,
        color: colors.paragraph
    },
    mapContainer: {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    map: {
        height: `${MAP_HEIGHT}px`,
        zIndex: 0
    },
    mapFader: {
        position: 'absolute',
        left: '-25%',
        width: '150%',
        height: '100%',
        pointerEvents: 'none'
    },
    bannerImage: { height: '60%', objectFit: 'contain' },
    bottomSheet: {
        width: '100%',
        height: '100%'
    },
    bottomSheetContent: {
        zIndex: 1,
        boxShadow: `0 -8px 12px ${colors.shadow}`,
        width: '100%',
        backgroundColor: colors.white,
        padding: 20,
        pointerEvents: 'auto',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    },
    widgetContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    lineDivider: {
        marginTop: 30,
        marginBottom: 20,
        height: 1,
        width: '100%',
        backgroundColor: colors.border
    }
} as Record<string, CSSProperties>;
